module.exports = __webpack_public_path__ + "img/2020-04-10.8edf0845.jpg";